export default {
      id: "ic_check_green-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_check_green-usage",
      toString: function () {
        return this.url;
      }
    }